module.exports = __webpack_public_path__ + "static/media/artnguideW.b43b4d6c.svg";